import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { EmployeeVisitDto, WorkOrdersService } from '../api';
import { EmployeeVisitsStore } from './state/employeeVisits.store';
import { EmployeeVisitsQuery } from './state/employeeVisits.query';
import { DateService } from 'src/app/shared/services/date.service';

@Injectable({
  providedIn: 'root',
})
export class EmployeeVisitsRepository {
  constructor(
    private workOrderService: WorkOrdersService,
    private employeeVisitsStore: EmployeeVisitsStore,
    private employeeVisitsQuery: EmployeeVisitsQuery
  ) {}

  loadWorkOrderEmployeeVisits = async (workOrderId: number) => {
    const employeeVisits = await firstValueFrom(this.workOrderService.getVWorkOrdersEmployeeVisits(workOrderId, '1'));

    employeeVisits.forEach((visit) => {
      this.employeeVisitsStore.upsert(visit.id as number, visit);
    });
  };

  storeCreatedEmployeeVisits(createdEmployeeVisits: EmployeeVisitDto[], activeWorkOrderId: number) {
    if (createdEmployeeVisits) {
      let storedEmployeeVisits = this.employeeVisitsQuery.getAll({
        filterBy: [(entity) => entity.workOrderId === activeWorkOrderId],
      });

      const lowestId =
        storedEmployeeVisits.length > 0
          ? (storedEmployeeVisits.reduce((previous, current) => {
              return current.id! < previous.id! ? current : previous;
            }).id as number)
          : 0;

      let counterId = lowestId < 0 ? lowestId : 0;
      createdEmployeeVisits.map((visit) => {
        counterId--;
        visit.id = counterId;
      });

      this.employeeVisitsStore.upsertMany(createdEmployeeVisits);
    }
  }

  checkIfEmployeeVisitsOverlap(
    employeeId: number,
    workOrderId: number,
    startDate: Date,
    endDate: Date,
    employeeVisitId?: number
  ) {
    let employeeVisitOverlaps = false;
    let storedEmployeeVisits = this.employeeVisitsQuery.getAll({
      filterBy: [
        (entity) =>
          entity.workOrderId === workOrderId &&
          entity.employeeId === employeeId &&
          (employeeVisitId ? entity.id != employeeVisitId : true),
      ],
    });

    if (storedEmployeeVisits) {
      employeeVisitOverlaps = storedEmployeeVisits.some((ev) =>
        DateService.checkIfDatesRangeOverlap(startDate, endDate, new Date(ev.startDate!), new Date(ev.endDate!))
      );
    }

    return employeeVisitOverlaps;
  }
}
